import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import AddProduct from "../EditBrand";
import { brandsAsyncThunk, categoryAsyncThunk, tagsAsyncThunk } from "../../Products/reducer/productSlice";
import { Bars } from "react-loader-spinner";
import { fetchBrandById, reset } from "../reducer/brandDetailsSlice";

const InitMiddlewareEditBrand:React.FC<any> = (props) => {
  const { isLoading, isSuccess, editBrandRes } = useSelector(
    (state: any) => state.rootReducer?.brandDetail
  );
  const navigate = useNavigate();

  let { brandId } = useParams();

  useEffect(() => {
    if (brandId) {
      store.dispatch(fetchBrandById(brandId));
    }

    return () => {
      store.dispatch(reset())
    }
  }, [brandId]);

  useEffect(() => {
    const data: any = [
      {
        label: "Brands",
        link: `/categories`,
      },
      {
        label: "Edit brand",
        link: ``,
      },
    ];
    store.dispatch(addBreadcrumb(data));
  }, []);
console.log('editBrandRes', editBrandRes, isSuccess);
  useEffect(() => {
    if (isSuccess && editBrandRes?.success === true) {
      navigate("/brands");
    }
  }, [isSuccess, editBrandRes, navigate]);


    if (isLoading.brandDetails) {
      return (
        <div className="flex items-center justify-center w-full h-screen">
          <Bars
            height="80"
            width="80"
            color="#2460a2"
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      );
    }
  

  // if (isSuccess && editBrandRes?.data?.success === true) {
  //   navigate("/brands")
  //   return null;
  // } else {
    return <AddProduct {...props} />;
  // }
};

export default InitMiddlewareEditBrand;
